import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import View from './view';
import OrbitViewport from '../viewports/orbit-viewport';
import OrbitController from '../controllers/orbit-controller';
export default class OrbitView extends View {
  constructor(props = {}) {
    super(props);
    this.props.orbitAxis = props.orbitAxis || 'Z';
  }

  get ViewportType() {
    return OrbitViewport;
  }

  get ControllerType() {
    return OrbitController;
  }

}

_defineProperty(OrbitView, "displayName", 'OrbitView');
//# sourceMappingURL=orbit-view.js.map